export enum AuthPaths {
  BASE = '/auth',
  SIGN_IN = 'sign-in',
  SIGN_UP = 'sign-up',
  LOGOUT = 'logout',
  PHONE_CODE = 'phone-code',
}
